var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCornerArrow = function SvgCornerArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 10",
    height: 10,
    width: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.105 9.454h1.992L14 5 9.097.545H7.105l4.118 3.803H0v5.106h1.38V5.652h9.844L7.105 9.454Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};
export default SvgCornerArrow;